import React from 'react';
import { connect } from 'react-redux';
import StatisticsByRefererContent from './StatisticsByRefererContent.js';
import { actions } from './StatisticsByRefererContent.actions';

const StatisticsByRefererContentComponent = connect(
    function mapStateToProps(state) {
        const storedMetrics = state?.statistics?.data?.parameters?.metricsBinary
            || state?.serverStorage?.store?.reportByReferer?.metrics;
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByRefererContent);

export default StatisticsByRefererContentComponent;
